var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgOv4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.98121 1.40051C6.5493 0.990819 8.08493 0.560513 9.54387 0.153883C11.0451 -0.271472 12.4272 0.194242 13.3745 1.43629C14.2991 2.63805 15.27 3.90761 16.2773 5.17615C17.3023 6.48991 17.8114 8.15329 17.4381 9.5137C17.0717 10.8534 16.6315 12.1687 16.1175 13.4594C15.5937 14.7698 14.1845 15.7959 12.5791 16.2293C11.011 16.639 9.47538 17.0693 8.01644 17.4759C6.51523 17.9013 5.1331 17.4355 4.18582 16.1935C3.26121 14.9917 2.2903 13.7222 1.28301 12.4536C0.257975 11.1399 -0.251134 9.47648 0.122165 8.11608C0.488602 6.77633 0.928817 5.46109 1.44281 4.17036C1.96662 2.85996 3.37577 1.83384 4.98121 1.40051Z",
    fill: "#FEC106"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgOv4);
export default __webpack_public_path__ + "static/media/prog-ov-4.08649d9b6cca6b7bf98975134862e6ac.svg";
export { ForwardRef as ReactComponent };